// Description: Menu js
document.addEventListener("DOMContentLoaded", function (event) {
  //var current_url = window.top.location.href;
  var isMobileViewport = window.matchMedia("(max-width: 991px)").matches;

  // The desktop menu remains in the mobile DOM but is not visible. Measuring
  // it here forces unnecessary layout work before the page becomes interactive.
  if (!isMobileViewport) {
    document
      .querySelectorAll(".horizontal-menu .mega-menu-container")
      .forEach(function (element) {
      if (element.classList.contains("right")) {
        if (element.classList.contains("full-width")) {
          element.closest("li").classList.remove();
          element.closest("li").classList.add("li-top-item", "mega-right");
        } else {
          element.closest("li").classList.remove();
          element.closest("li").classList.add("li-top-item", "right");

          var menubar = document.querySelector(".oc-menu-bar");
          var menu = menubar.offsetLeft;
          var dropdown = element.closest("li").offsetLeft;

          var dropdownRight = menubar.offsetWidth - dropdown;

          var i = dropdownRight + element.offsetWidth - menubar.offsetWidth;

          if (i > 0) {
            element.style.marginInlineEnd = "-" + i + "px";
          } else if (i < 0 && document.documentElement.dir === "rtl") {
            element.style.marginInlineEnd = i + "px";
          }
        }
      }
      if (element.classList.contains("left")) {
        if (!element.classList.contains("full-width")) {
          //var menubar = document.querySelector(".oc-menu.horizontal-menu.oc-menu-bar")
          var menubar = document.querySelector(
            ".header-inner .container-inner .logo-container"
          );
          var menu = menubar.getBoundingClientRect().left;
          // var dropdown = element.closest("li").offsetLeft;
          var dropdown = element.closest("li").getBoundingClientRect().left;
          var i =
            dropdown +
            element.offsetWidth -
            (menu +
              document.querySelector(
                ".oc-menu.horizontal-menu.oc-menu-bar .ul-top-items"
              ).offsetWidth);
          var i =
            dropdown +
            element.offsetWidth -
            (menu +
              document.querySelector(
                ".oc-menu.horizontal-menu.oc-menu-bar .ul-top-items"
              ).offsetWidth);
          i = dropdown - menu - 12;
          if (i > 0) {
            element.style.marginInlineStart = "-" + i + "px";
          } else if (i < 0 && document.documentElement.dir === "rtl") {
            element.style.marginInlineStart = i + "px";
          }
        }
      }
      });
  }
  //
  document.querySelectorAll(".sub-menu-container").forEach(function (element) {
    var total_cols = 0;
    element.querySelectorAll(".sub-item2-content").forEach(function (element) {
      var cols = parseFloat(element.dataset.cols);
      if (total_cols == 0) {
        element.style.clear = "left";
      }
      total_cols += cols;
      if (total_cols > 12) {
        element.style.clear = "left";
        total_cols = cols;
      }
      if (total_cols == 12) {
        total_cols = 0;
      }
    });
  });

  if (document.querySelector(".vertical-menu .oc-menu-bar") != null) {
    document
      .querySelector(".vertical-menu .oc-menu-bar")
      .addEventListener("click", function () {
        var effect = document.querySelector(
          ".vertical-menu .menu-effect"
        ).value;
        if (effect == "none") {
          document
            .querySelector(".vertical-menu .ul-top-items")
            .classList.toggle("d-block");
        }

        if (effect == "fade") {
          document.querySelector(".vertical-menu .ul-top-items").fadeToggle();
        }

        if (effect == "slide") {
          document.querySelector(".vertical-menu .ul-top-items").slideToggle();
        }
      });
  }

  document
    .querySelector(".mobile-menu .oc-menu-bar .right")
    ?.addEventListener("click", function () {
      var effect = document.querySelector(".mobile-menu .menu-effect").value;
      if (effect == "none") {
        document
          .querySelector(".mobile-menu .ul-top-items")
          .classList.toggle("d-block");
      }
      if (effect == "fade") {
        document.querySelector(".mobile-menu .ul-top-items").fadeToggle();
      }
      if (effect == "slide") {
        document.querySelector(".mobile-menu .ul-top-items").slideToggle();
      }
    });

  document.querySelectorAll(".oc-menu").forEach(function (element) {
    var $mobile = element.classList.contains("mobile-menu");
    if (($mobile && !isMobileViewport) || (!$mobile && isMobileViewport)) {
      return;
    }
    var effect = element.querySelector(".menu-effect").value;
    if ($mobile) {
      const topClickShow = element.querySelectorAll(
        ".li-top-item .top-click-show"
      );
      topClickShow.forEach(function (selement) {
        selement.addEventListener("click", function () {
          selement.closest(".li-top-item").classList.toggle("expand");
          if (effect == "none") {
            selement
              .closest(".li-top-item")
              .querySelector(".sub-menu-container")
              .classList.toggle("d-block");
          }
        });
      });

      const secondClickShow = element.querySelectorAll(
        ".li-second-items .second-click-show"
      );
      secondClickShow.forEach(function (selement) {
        selement.addEventListener("click", function () {
          selement.closest(".li-second-items").classList.toggle("expand");
          if (effect == "none") {
            selement
              .closest(".li-second-items")
              .querySelector(".flyout-third-items")
              .classList.toggle("d-block");
          }
        });
      });
    } else {
      element.querySelectorAll(".li-top-item").forEach(function (liTopItem) {
        liTopItem.addEventListener("mouseover", function () {
          var effect =
            this.closest(".oc-menu").querySelector(".menu-effect").value;
          if (effect == "none") {
            document
              .querySelectorAll(".sub-menu-container")
              .forEach(function (subMenuContainer) {
                subMenuContainer.style.display = "none";
              });
            if (this.querySelector(".sub-menu-container") != null) {
              this.querySelector(".sub-menu-container").style.display = "block";
            }
          }
        });

        liTopItem.addEventListener("mouseout", function () {
          var effect =
            this.closest(".oc-menu").querySelector(".menu-effect").value;
          if (effect == "none") {
            if (this.querySelector(".sub-menu-container") != null) {
              this.querySelector(".sub-menu-container").style.display = "none";
            }
          }
        });
      });

      element
        .querySelectorAll(".li-second-items")
        .forEach(function (liSecondItem) {
          liSecondItem.addEventListener("mouseover", function () {
            var effect =
              this.closest(".oc-menu").querySelector(".menu-effect").value;
            if (effect == "none") {
              document
                .querySelectorAll(".flyout-third-items")
                .forEach(function (flyoutThirdItems) {
                  flyoutThirdItems.style.display = "none";
                });
              if (this.querySelector(".flyout-third-items") != null) {
                this.querySelector(".flyout-third-items").style.display =
                  "block";
              }
            }
          });

          liSecondItem.addEventListener("mouseout", function () {
            var effect =
              this.closest(".oc-menu").querySelector(".menu-effect").value;
            if (effect == "none") {
              if (this.querySelector(".flyout-third-items") != null) {
                this.querySelector(".flyout-third-items").style.display =
                  "none";
              }
            }
          });
        });
    }
  });
});
